import { render, staticRenderFns } from "./BigScreenData.vue?vue&type=template&id=2bab767b&scoped=true&"
import script from "./BigScreenData.vue?vue&type=script&lang=js&"
export * from "./BigScreenData.vue?vue&type=script&lang=js&"
import style0 from "./BigScreenData.vue?vue&type=style&index=0&id=2bab767b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bab767b",
  null
  
)

export default component.exports